/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "Sobre";
var Access = "Acesso";
var Account = "Conta";
var Actions = "Ações";
var Active = "Ativo";
var Add = "Incluir";
var Address = "Address";
var Advanced = "Avançado";
var Aliases = "Aliases";
var all = "todos";
var All = "Todos";
var Apply = "Aplicar";
var April = "Abril";
var Arbitrary = "Arbitrário";
var Assign = "Designar";
var August = "Agosto";
var Back = "Voltar";
var Basic = "Básico";
var BNPP_EU = "BNPP_EU";
var Cancel = "Cancelar";
var Category = "Categoria";
var Classic = "Clássica";
var Clear = "Limpar";
var CLI = "CLI";
var Close = "Fechar";
var Clusters = "Clusters";
var code = "código";
var Complete = "Concluído";
var Completed = "Concluído";
var Compliance = "Conformidade";
var Compliant = "Em conformidade";
var Configuration = "Configuração";
var Configure = "Configurar";
var Confirm = "Confirmar";
var Connect = "Conectar";
var Connected = "Conectado";
var Connecting = "Conectando";
var Containers = "Contêineres";
var Country = "Country";
var Create = "Criar";
var Created = "Criado";
var Creating = "Criando";
var Critical = "Crítico";
var Current = "Atual";
var Custom = "Customizado";
var Dallas = "Dallas";
var Datacenter = "Datacenter";
var Datacenters = "Data centers";
var December = "Economia";
var Delete = "Excluir";
var Deleting = "Excluindo";
var Deploying = "Implementando";
var Disabled = "Desativado";
var Disconnect = "Desconectar";
var Docs = "Docs";
var Documentation = "Documentação";
var Done = "Done";
var Download = "Download";
var Draft = "Rascunho";
var Edit = "Editar";
var Enabled = "Ativado";
var Encryption = "Criptografia";
var End = "Terminar";
var Enterprise = "Enterprise";
var Establish = "Estabelecer";
var Expired = "Expirada";
var Failed = "Com falha";
var February = "Fevereiro";
var Filter = "Filtro";
var Filters = "Filtros";
var Finalizing = "Finalizando";
var Frankfurt = "Frankfurt";
var Free = "Grátis";
var Friday = "Sexta-feira";
var Geography = "Geografia";
var Help = "Ajuda";
var hour = "hora";
var Hour = "Hora";
var hr = "hr";
var IAM = "IAM";
var ID = "ID";
var Images = "Imagens";
var Inactive = "Inativo";
var Incomplete = "Incompleto";
var Information = "Informações";
var Infrastructure = "Infraestrutura";
var Instance = "Instância";
var Instances = "INSTÂNCIAS";
var Integrations = "Integrações";
var Invalid = "Inválido";
var January = "Janeiro";
var July = "Julho";
var June = "Junho";
var Key = "Chave";
var Launch = "Ativar";
var Lite = "Lite";
var Loading = "Carregamento";
var Location = "Local";
var Locations = "Localizações";
var Logging = "Criação de log";
var London = "Londres";
var March = "Março";
var May = "Maio";
var Metro = "Área metropolitana";
var Minute = "Minuto";
var mo = "mês";
var Monday = "Segunda-feira";
var Monitoring = "Monitoring";
var Month = "Mês";
var more = "mais";
var Name = "Nome";
var Namespace = "Namespace:";
var Namespaces = "Namespaces";
var Next = "Avançar";
var No = "Não";
var None = "Nenhum";
var Normal = "Normal";
var Note = "Nota";
var Notification = "Notificação";
var November = "Novembro";
var Objects = "Objetos";
var October = "Outubro";
var Off = "Desativado";
var OK = "OK";
var On = "Ativado";
var Open = "Abrir";
var Osaka = "Osaka";
var Overview = "Visão geral";
var Packages = "Pacotes";
var Pattern = "Padrão";
var Pending = "Pendente";
var Plan = "Plano";
var Premium = "Premium";
var Previous = "Anterior";
var Product = "Produto";
var Products = "Produtos";
var Project = "Project";
var Projects = "Projetos";
var Property = "Propriedade";
var provided = "fornecido";
var Provider = "Provedor";
var Provisioning = "Fornecimento";
var Ready = "Pronto";
var Refresh = "Atualizar";
var region = "região";
var Region = "Região";
var Remove = "Remover";
var Renew = "Renovar";
var Repositories = "Repositórios";
var Requested = "Solicitada";
var Required = "Obrigatório";
var Reservations = "Reservas";
var Reset = "Reconfigurar";
var resources = "recursos";
var Resources = "Recursos";
var Results = "Resultados";
var Review = "Revisar";
var Routing = "Roteamento";
var Satellite = "Satellite";
var Saturday = "Sábado";
var Save = "Salvar";
var Scanning = "Varrendo";
var Schedule = "Planejar";
var Search = "Procura";
var Secret = "Segredo";
var Select = "Selecionar";
var Sending = "Enviando";
var September = "Setembro";
var Serverless = "Serverless";
var Service = "Serviço";
var Settings = "Configurações";
var Size = "Tamanho";
var Sort = "Ordenar";
var Source = "Origem";
var Start = "Iniciar";
var State = "Estado";
var Status = "Status";
var Storage = "Storage";
var Submit = "Enviar";
var Subscription = "Assinatura";
var Success = "Sucesso";
var Summary = "Resumo";
var Sunday = "Domingo";
var Sydney = "Sidney";
var tag = "identificação";
var tags = "tags";
var Tags = "Tags";
var Thursday = "Quinta-feira";
var Tokyo = "Tóquio";
var Topics = "Tópicos";
var Toronto = "Toronto";
var Total = "Total";
var Trash = "Lixeira";
var Trial = "Avaliação";
var Tuesday = "Terça-feira";
var Unknown = "Desconhecido";
var Unsupported = "Não suportado";
var Update = "Atualizar";
var Upgrade = "Fazer upgrade";
var Value = "Valor";
var Values = "Valores";
var Version = "Versão";
var View = "Visualizar";
var Warning = "Aviso";
var Wednesday = "Quarta-feira";
var Workloads = "Cargas de trabalho";
var Yes = "True";
var Zone = "Zona";
var Zones = "Zones";
var ptBr = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' já existe. Insira outro nome.",
	"'Day of week' matches in addition to 'Day of month'": "'Dia da semana' corresponde, além do 'Dia do mês'",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "'Dia da semana' corresponde, além de 'Dia do mês'. A expressão é acionada todos os dias.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} itens selecionados",
	"{{count}} resources": "{{count}} recursos",
	"{{count}} resources included": "{{count}} recursos incluídos",
	"{{current}} of {{total}} pages": "{{current}} de {{total}} páginas",
	"{{datahookName}} response": "Resposta {{datahookName}}",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "Padrões de {{label}}",
	"{{min}}–{{max}} items": "{{min}}–{{max}} itens",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} de {{total}} itens",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} módulos, {{resourcesCount}} recursos",
	"{{name}} requires the following option(s) in order to deploy.": "O {{name}} requer a(s) opção(ões) a seguir para ser implementado.",
	"{{price}} per {{unit}}": "{{price}} por {{unit}}",
	"{{price}} per month": "{{price}} por mês",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mês",
	"{{resourcesCount}} resources": "{{resourcesCount}} recursos",
	"{{rolesCount}} Role": "{{rolesCount}} Função",
	"{{rolesCount}} Roles": "{{rolesCount}} Funções",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} tópico ativo para esta instância.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} tópicos ativos para esta instância.",
	"{{value}} percent status progress": "{{value}} por cento de progresso de status",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (criar um novo cluster para experimentar a versão beta)",
	"{{version}} (update to an earlier version first)": "{{version}} (atualizar para uma versão anterior primeiro)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Deve-se ter uma instância do Cloud Object Storage para criar uma localização do Satellite.</span> <a>Saiba mais.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / instância",
	"1 item selected": "1 item selecionado",
	"1 of 1 page": "Página 1 de 1",
	"1 role": "1 função",
	"1–1 of 1 item": "1 – 1 de um item",
	"A collection of keys that belong to your service instance.": "Uma coleção de chaves que pertencem à sua instância de serviço.",
	"A key can only have 5 aliases.": "Uma chave só pode ter 5 aliases.",
	"A Key Protect key": "Uma chave do Key Protect",
	"A location name is required. ": "Um nome do local é necessário. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "Um serviço de gerenciamento de chaves com vários locatários. Crie e gerencie chaves criptográficas para criptografar dados em seus aplicativos e controlar o acesso aos seus dados.",
	"A name is required.": "O nome é obrigatório.",
	"A rotation policy of 12 months is recommended": "Recomenda-se uma política de rotação de 12 meses",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "É necessária uma autorização de serviço para serviço entre {{sourceServiceDisplayName}} e {{serviceDisplayName}} para associar a chave de criptografia. O Key Protect criará uma com o seu consentimento. Ou você pode criar uma manualmente.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "Um serviço de gerenciamento de chaves de locatário único. Crie e gerencie chaves criptográficas com a criação de área segura de chave que é fornecida pelo Módulo de Segurança de Hardware controlado por cliente dedicado. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "Uma tag pode ter apenas caracteres alfanuméricos, espaços, sublinhados, traços, pontos e um caractere de dois-pontos.",
	"A tag cannot end with a colon.": "Uma tag não pode terminar com dois-pontos.",
	"A tag cannot include more than 128 characters.": "Uma tag não pode ter mais de 128 caracteres.",
	"A tag cannot start with a colon.": "Uma tag não pode começar com dois-pontos.",
	"A tag should not have spaces around a colon.": "Uma tag não deve possuir espaços em torno de dois pontos.",
	About: About,
	Access: Access,
	"Access management tags": "Tags de gerenciamento de acesso",
	"Access management tags (optional)": "Tags de gerenciamento de acesso (opcional)",
	"Access management tags help you apply flexible access policies on specific resources.": "As tags de gerenciamento de acesso ajudam o usuário a aplicar políticas de acesso flexíveis em recursos específicos.",
	Account: Account,
	"Account type": "Tipo de Conta",
	"Action required": "Ação necessária",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Promoções ativas",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "A coleta de eventos do Activity Tracker está ativada para este recurso e é enviada para os destinos conforme definido pela sua configuração de roteamento.",
	"Activity tracker events": "Eventos do rastreador de atividade",
	"Activity tracking": "Acompanhamento de atividade",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Inclua um único namespace ou diversos namespaces em sua lista de namespaces específicos.",
	"Add a single project or multiple projects to your specific project's list.": "Inclua um único projeto ou diversos projetos em sua lista de projetos específicos.",
	"Add Activity tracker event collection": "Incluir coleção de eventos do Activity Tracker",
	"Add activity tracking": "Incluir rastreamento de atividade",
	"Add event collection": "Incluir coleção de eventos",
	"Add hosts": "Incluir hosts",
	"Add hosts to meet the minimum service requirements.": "Inclua hosts para atender aos requisitos mínimos de serviço.",
	"Add key alias (optional)": "Incluir alias de chave (opcional)",
	"Add key description (optional)": "Incluir descrição de chave (opcional)",
	"Add logging": "Incluir criação de log",
	"Add monitoring": "Incluir monitoramento",
	"Add namespace": "Incluir namespace",
	"Add New": "Incluir novo",
	"Add project": "Incluir projeto",
	"Add storage": "Incluir armazenamento",
	"Add tags": "Incluir tags",
	"Add to estimate": "Incluir na estimativa",
	"Add to existing": "Incluir em existente",
	"Add to project": "Incluir no projeto",
	"Adding ...": "Incluindo...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Trate de quaisquer ações necessárias abaixo para provisionar o seu serviço com sucesso. É possível concluir essas etapas agora ou após criar o serviço.",
	"Address field": "Campo de endereço",
	Advanced: Advanced,
	"Advanced options": "Opções avançadas",
	"After connection": "Após a conexão",
	"After the service cluster is created, assign storage to the cluster.": "Após o cluster de serviços ser criado, designe armazenamento ao cluster.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Após a desconexão do Event Notifications, a instância {{serviceName}} será removida da lista de serviços de origem na instância do Event Notifications.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Os aliases só podem conter caracteres alfanuméricos e -_.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Os aliases devem ter no mínimo 2 caracteres e no máximo 90 caracteres.",
	all: all,
	All: All,
	"All audit events (default target)": "Todos os eventos de auditoria (destino padrão)",
	"All audit events from your account will be sent to a new instance": "Todos os eventos de auditoria de sua conta serão enviados para uma nova instância",
	"All audit events from your account will be sent to an existing instance": "Todos os eventos de auditoria de sua conta serão enviados para uma instância existente",
	"All namespaces": "Todos os namespaces",
	"All namespaces not supported": "Todos os namespaces não suportados",
	"All platform logs": "Todos os logs de plataforma",
	"All prerequisite services are installed on the location.": "Todos os serviços de pré-requisito são instalados no local.",
	"All projects": "Todos os projetos",
	"All projects not supported": "Todos os projetos não suportados",
	"All regions": "Todas as regiões",
	"All resource groups": "Todos os grupos de recursos",
	"All secret groups": "Todos os grupos de segredos",
	"All types": "Todos os tipos",
	"All zone names must be unique": "Todos os nomes de zona devem ser exclusivos",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Ações permitidas para a função {{roleName}} ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "Já possui uma conta? <a>Efetuar login</a>",
	"An error occurred when fetching secrets. Try again later.": "Ocorreu um erro ao buscar segredos. Tente novamente mais tarde.",
	"An instance of Event Notifications <a>Create new instance</a>": "Uma instância do Event Notifications <a>Criar nova instância</a>",
	"An unexpected error occurred.": "Ocorreu um erro inesperado.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analise e gerencie os logs para rápida resolução de problema e prevenção proativa de tempo de inatividade. <a>Saiba mais</a>",
	Apply: Apply,
	"Apply a code": "Aplicar um código",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "Tem certeza de que deseja desconectar a instância {{serviceName}} da instância \"{{ENInstanceName}}\"?",
	"Are you sure you want to close the side panel?": "Tem certeza de que deseja fechar o painel lateral?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "Tem certeza de que deseja fechar esse painel? Todas as seleções que você tiver feito serão perdidas.",
	"Are you sure?": "Tem certeza?",
	Assign: Assign,
	"Associate key": "Associar chave",
	"Attachment name": "Nome do anexo",
	"Audit event collection is already enabled for this resource": "A coleção de eventos de auditoria já está ativada para este recurso",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "A coleção de eventos de auditoria é recomendada para otimizar a resolução de problemas e reduzir o tempo de inatividade",
	"Audit events (error)": "Eventos de auditoria (erro)",
	"Audit events from {{region}} will be sent to a new instance": "Os eventos de auditoria de {{region}} serão enviados para uma nova instância",
	"Audit events from {{region}} will be sent to an existing instance": "Os eventos de auditoria de {{region}} serão enviados para uma instância existente",
	"Audit events in {{region}}": "Eventos de auditoria em {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Os eventos de auditoria serão coletados dos serviços ativados da IBM Cloud de acordo com o escopo de roteamento definido.",
	"Audit events...": "Eventos de auditoria...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "A autenticação é necessária ou você não tem as permissões corretas para executar esta ação.",
	"Authorization error": "Erro de autorização",
	"Authorization met": "Autorização atendida",
	"Authorization needed": "Autorização necessária",
	"Authorize now": "Autorizar agora",
	"Authorizing...": "Autorizando...",
	Back: Back,
	"Base URI": "URI base",
	"Base64 encoded key material": "Material de chave codificado em Base64",
	Basic: Basic,
	"Before you begin": "Antes de Iniciar",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Antes que seu projeto possa validar ou implementar configurações, o serviço Projects precisa ser autorizado nessa conta para se comunicar com o Schematics, Catalog Management, Secrets Manager e o Resource Controller. Um usuário com o acesso necessário a esses serviços pode conceder autorizações automaticamente, criando um projeto nessa conta ou criando o serviço para autorizações de serviço manualmente. Essa autorização é necessária apenas uma vez.",
	"Billing information": "Informações de faturamento",
	"Billing period": "Período de faturamento",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Nome do depósito",
	"By {{name}}": "Por {{name}}",
	"By clicking Save, you are creating the following access:": "Ao clicar em Salvar, você estará criando o acesso a seguir:",
	"Can't retrieve details": "Não é possível recuperar detalhes",
	Cancel: Cancel,
	"Cannot list integrations!": "Não é possível listar integrações.",
	"Cannot view keys in this instance": "Não é possível visualizar chaves nesta instância",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Aplicam-se os encargos. <a>Saiba mais</a>",
	"Choose a cluster version": "Escolha uma versão do cluster",
	"Choose a key ring": "Escolha um conjunto de chaves",
	"Choose a resource group": "Escolha um grupo de recursos",
	"Choose account...": "Escolher conta...",
	"Choose an existing HPCS instance.": "Escolha uma instância HPCS existente.",
	"Choose an existing Key Protect instance.": "Escolha uma instância existente do Key Protect.",
	"Choose an instance": "Escolha uma instância",
	"Choose an option": "Escolher uma opção",
	"Choose category...": "Escolher categoria...",
	"Choose location": "Escolher localização",
	"Choose plan": "Escolher plano",
	"Choose property...": "Escolher propriedade...",
	"Choose provider...": "Escolher provedor...",
	"Choose secret...": "Escolher segredo...",
	"Choose service instance...": "Escolher instância de serviço...",
	"Choose source name...": "Escolher o nome de origem...",
	"Choose source...": "Escolher origem...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Escolha qual instância do IBM Cloud Monitoring receberá métricas de plataforma de instâncias de serviço ativadas em toda IBM Cloud.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Escolha qual instância do IBM Log Analysis receberá logs de plataforma de instâncias de serviço ativadas em toda IBM Cloud.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Limpar todos",
	"Clear all selected items": "Limpar todos os itens selecionados",
	"Clear filters": "Limpar Filtros",
	"Clear selected": "Limpar selecionado",
	"Clear selected item": "Limpar item selecionado",
	"Clear selection": "Desmarcar seleção",
	CLI: CLI,
	Close: Close,
	"Close menu": "Fechar menu",
	"Close page navigation menu": "Fechar o menu de navegação da página",
	"Close Panel": "Fechar painel",
	"Close Push Panel": "Fechar Painel push",
	"Closing side panel": "Fechar painel lateral",
	"Cloud Logs": "Logs em nuvem",
	"Cloud Logs instance": "Instância do Cloud Logs",
	"Cloud Logs instance name": "Nome da instância do Cloud Logs",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Instância do Cloud Object Storage",
	"Cluster \"{{name}}\" is being deleted.": "O cluster \"{{name}}\" está sendo excluído.",
	"Cluster management": "Gerenciamento de cluster",
	"Cluster version": "Versão do cluster",
	"Cluster version cannot be updated.": "A versão do cluster não pode ser atualizada.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Amostra de código",
	"Collapse all rows": "Reduzir todas as linhas",
	"Collapse group": "Reduzir grupo",
	"Collapse row": "Reduzir linha",
	"Collapse summary": "Reduzir o resumo",
	"Compact (24px)": "Compacta (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Detalhes de configuração",
	"Configuration name": "Guia de configuração",
	Configure: Configure,
	"Configure activity tracking": "Configurar o rastreamento de atividade",
	"Configure encryption": "Configurar criptografia",
	"Configure logging": "Configurar criação de log",
	"Configure monitoring": "Configurar monitoramento",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Conectar-se ao Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Conecte sua instância {{serviceName}} a uma instância existente do Event Notifications.",
	Connected: Connected,
	"Connected instance": "Instância conectada",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "A instância conectada do Event Notifications não existe. Entre em contato com o administrador.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Entre em contato com o administrador da conta para acessar um plano para provisionar o Key Protect.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Entre em contato com o administrador da conta para acessar um grupo de recursos para provisionar o Key Protect.",
	"Contact your administrator for access.": "Entre em contato com o administrador para obter acesso.",
	"Contact your administrator for additional assistance.": "Entre em contato com o administrador para obter assistência adicional.",
	"Container registry": "Registro de contêiner",
	Containers: Containers,
	"Copied to clipboard": "Copiado para área de transferência",
	"Copy to clipboard": "Copiar para a área de transferência",
	"Cost details": "Detalhes do custo",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "Não foi possível carregar informações de precificação. Atualize a página ou tente novamente mais tarde.",
	Country: Country,
	Create: Create,
	"Create a key": "Criar uma chave",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Crie um Destino de roteamento de logs para dar suporte ao gerenciamento e à análise de logs para rápida resolução de problema e prevenção proativa de tempo de inatividade. <a>Saiba mais</a>",
	"Create a new instance to get started.": "Crie uma nova instância para começar.",
	"Create a project": "Criar um projeto",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Crie um local do Satellite para trazer a IBM Cloud para qualquer lugar. Para obter mais informações, <a>consulte a documentação.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Crie um destino de roteamento de evento do Activity Tracker e uma rota para dar suporte ao monitoramento e à auditoria da atividade da IBM Cloud para aumentar a segurança e a conformidade. <a>Saiba mais</a>",
	"Create an encryption key or import your own key.": "Crie uma chave de criptografia ou importe sua própria chave.",
	"Create cluster": "Criar cluster",
	"Create failed": "Criação com falha",
	"Create instance": "Criar instância",
	"Create location": "Criar localização",
	"Create new": "Criar novo",
	"Create new instance": "Criar nova instância",
	"Create new key": "Criar nova chave",
	"Create new secret": "Criar um novo segredo",
	"Create reference": "Criar referência",
	"Create resource": "Criar recurso",
	"Create Satellite location": "Criar local do Satellite",
	"Create secret": "Criar segredo",
	"Create services": "Criar serviços",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Crie tópicos, destinos e assinaturas no Event Notifications para ser notificado sobre eventos gerados por seu {{serviceName}}",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Criando...",
	"Creating...": "Criando...",
	Critical: Critical,
	"CRON expression": "Expressão cron",
	Current: Current,
	Custom: Custom,
	"Custom access": "Acesso customizado",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Bloco de argumentos do datahook",
	"Datahook Params": "Parâmetros do datahook",
	"Datahook response": "Resposta do datahook",
	"Day of month": "Dia do mês",
	"Day of Month (UTC)": "Dia do mês (UTC)",
	"Day of week": "Dias da semana",
	"Day of week (UTC)": "Dia da semana (UTC)",
	December: December,
	"Dedicated hosts": "Hosts dedicados",
	"Default target": "Destino padrão",
	"Default title": "Título padrão",
	"Define project details": "Definir detalhes do projeto",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Defina as sincronizações recorrentes dos eventos gerados por este evento. Selecione um padrão predefinido e customize-o de acordo com suas necessidades. Os planejamentos são especificados em Hora Universal Coordenada (UTC).",
	"Define the scope of audit events collected": "Definir o escopo dos eventos de auditoria coletados",
	Delete: Delete,
	"Delete cluster": "Excluir cluster",
	"Delete failed": "Exclusão com falha",
	"Delete retry wait": "Excluir espera de nova tentativa",
	"Delete the persistent storage used by this cluster": "Excluir o armazenamento persistente usado por esse cluster",
	Deleting: Deleting,
	"Deleting...": "Excluindo...",
	"Deploy failed": "Implementação falhou",
	"Deploy retry wait": "Implementar espera de nova tentativa",
	Deploying: Deploying,
	"Deployment ready": "Implementação pronta",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Versão descontinuada, o suporte terminará em {{when}}. Atualize a versão para continuar a receber suporte.",
	"Description (optional)": "Descrição (opcional)",
	"Description of the source": "Descrição da origem",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Desconectar o Event Notifications",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "Os rótulos de subdomínio DNS não devem ter mais de {{maxLength}} caracteres.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Concluir edição",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "Durante a atualização, seu cluster principal, nós do trabalhador, apps e recursos continuam a ser executados. Após a atualização ser concluída, é possível atualizar as versões do nó do trabalhador. Para obter instruções e mais informações sobre diferenças entre versões, <a>revise os docs</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Editar a integração do Activity Tracker",
	"Edit Array": "Editar matriz",
	"Edit columns": "Editar colunas",
	"Edit configuration": "Editar a configuração",
	"Edit details": "Editar detalhes",
	"Edit JSON": "Editar JSON",
	"Edit logging integration": "Editar integração de criação de log",
	"Edit secure value": "Editar valor seguro",
	"Edit tags": "Editar tags",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Ative as notificações de ciclo de vida para sua instância {{serviceName}} conectando uma instância de serviço Event Notifications.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Permite a supervisão, a conformidade e a auditoria das operações e dos riscos para gerenciar sua conta da IBM Cloud.",
	Encryption: Encryption,
	"Encryption key associated": "Chave de criptografia associada",
	"Encryption options menu": "Menu de opções de criptografia",
	End: End,
	"End date": "Data de encerramento",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Aprimore a sua experiência no Schematics com as integrações. Inicie incluindo as integrações hoje mesmo selecionando dentre as opções abaixo.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Insira um nome para a configuração da arquitetura implementável.  Por exemplo: production-vpc",
	"Enter a password": "Insira uma senha",
	"Enter a valid CRN": "Insira um CRN válido",
	"Enter array values. Quotations are added to values after you save.": "Insira valores de matriz. As citações são incluídas nos valores após o salvamento.",
	"Enter name and description": "Inserir nome e descrição",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Insira nomes para as zonas de host. Para alta disponibilidade, aloque os seus hosts ao longo dessas três zonas com base em suas zonas do provedor de infraestrutura. <a>Por que as zonas são necessárias?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Insira namespaces separados por uma vírgula. Depois que você clicar em Incluir, os novos namespaces serão incluídos na lista e selecionados automaticamente.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Insira projetos separados por uma vírgula. Depois que você clicar em Incluir, os novos projetos serão incluídos na lista e selecionados automaticamente.",
	"Enter source name": "Inserir nome de origem",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Insira o nome exato de um depósito existente em sua instância do Cloud Object Storage. Se nenhum nome for fornecido, um novo depósito será criado para você.",
	Enterprise: Enterprise,
	"Entire secret": "Segredo inteiro",
	"Environment (optional)": "Ambiente (opcional)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Os ambientes podem conter propriedades que são compartilhadas entre configurações relacionadas. Dentro da configuração, pode-se substituir quaisquer valores fornecidos pelo ambiente. <a>Saiba mais</a>",
	"Error": "Erro",
	"Error checking existing services status": "Erro ao verificar o status de serviços existentes",
	"Error checking host status": "Erro ao verificar o status do host",
	"Error checking storage status": "Erro ao verificar o status de armazenamento",
	"Error fetching tags": "Erro ao buscar tags",
	"Error icon": "Ícone de erro",
	"Error loading accounts": "Erro ao carregar contas",
	"Error loading categories": "Erro ao carregar categorias",
	"Error loading groups": "Erro ao carregar grupos",
	"Error loading instances": "Erro ao carregar instâncias",
	"Error loading keys": "Erro ao carregar chaves",
	"Error loading pricing": "Erro ao carregar a precificação",
	"Error loading properties": "Erro ao carregar propriedades",
	"Error loading providers": "Erro ao carregar provedores",
	"Error loading regions": "Erro ao carregar regiões",
	"Error loading resource groups": "Erro ao carregar grupos de recursos",
	"Error loading S2S auth": "Erro ao carregar autorização S2S",
	"Error loading secrets": "Erro ao carregar segredos",
	"Error loading source names": "Erro ao carregar os nomes de origem",
	"Error loading sources": "Erro ao carregar origens",
	"Error loading types": "Erro ao carregar tipos",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Erro ao validar esse código. Certifique-se de não incluir nenhuma aspa no código promocional.",
	Establish: Establish,
	"Estimate costs": "Estimar custos",
	"Estimated cost per instance": "Custo estimado por instância",
	"Estimated starting cost": "Custo inicial estimado",
	"Estimated total ({{count}} instances)": "Total estimado ({{count}} instâncias)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Instância do Event Notifications",
	"Event Notifications service instance": "Instância de serviço do Event Notifications",
	"Event Source Manager": "Gerenciador de origem de eventos",
	"Every 2 hours": "A cada 2 horas",
	"Every 2 minutes": "A cada 2 minutos",
	"Every 3 hours": "A cada 3 horas",
	"Every 4 hours": "A cada 4 horas",
	"Every 5 minutes": "A cada 5 minutos",
	"Every 6 hours": "A cada 6 horas",
	"Every 10 minutes": "A cada 10 minutos",
	"Every 15 minutes": "A cada 15 minutos",
	"Every day": "Todos os dias",
	"Every fifth day": "A cada quinto dia",
	"Every fourth day": "Todo quarto dia",
	"Every fourth month": "Todo quarto mês",
	"Every hour": "A cada hora",
	"Every minute": "A cada minuto",
	"Every month": "Todos os meses",
	"Every second day": "Todo segundo dia",
	"Every second month": "Todo segundo mês",
	"Every sixth month": "Todo sexto mês",
	"Every third day": "Todo terceiro dia",
	"Every third month": "Todo terceiro mês",
	"Examples: access:dev, proj:version-1": "Exemplos: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Exemplos: env:dev, version-1",
	"Existing instance": "Instância existente",
	"Exiting encryption selection": "Saindo da seleção de criptografia",
	"Expand all rows": "Expandir todas as linhas",
	"Expand group": "Expandir grupo",
	"Expand row": "Expandir linha",
	"Expand summary": "Expandir o resumo",
	Expired: Expired,
	"Expired (beta)": "Expirado (beta)",
	"Expires {{when}}": "Expira {{when}}",
	"Expires after beta": "Expira após o beta",
	"Extra large (64px)": "Extra grande (64px)",
	"Extra small (24px)": "Extra pequeno (24px)",
	Failed: Failed,
	"Failed to check permission": "Falha ao verificar a permissão",
	"Failed to create configuration": "Falha ao criar a configuração",
	"Failed to create key": "Falha ao criar a chave",
	"Failed to create policy": "Falha ao criar a política",
	"Failed to create project": "Falha ao criar o projeto",
	"Failed to fetch": "Falha ao buscar",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "Falha ao buscar instâncias do IBM Cloud Activity Tracker.",
	"Failed to fetch IBM Cloud Monitoring instances.": "Falha ao buscar instâncias do IBM Cloud Monitoring.",
	"Failed to fetch IBM Log Analysis instances.": "Falha ao buscar instâncias do IBM Log Analysis.",
	"failure state": "estado de falha",
	February: February,
	"Fetch data": "Buscar dados",
	Filter: Filter,
	"Filter instance by region": "Filtre a instância por região",
	"Filter...": "Filtrar...",
	Filters: Filters,
	"Filters:": "Filtros:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Finalizando cluster...",
	"Finalizing workers...": "Finalizando trabalhadores...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "Obtenha visibilidade operacional em seus recursos em Nuvem com o IBM Cloud Activity Tracker.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "Obtenha visibilidade operacional em seus recursos em Nuvem com o IBM Cloud Monitoring.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "Obtenha visibilidade operacional em seus recursos em Nuvem com o IBM Log Analysis.",
	"Get started": "Iniciar",
	"Get started with Security and Compliance Center": "Introdução ao Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Dê um alias à sua chave para facilitar uma futura recuperação.",
	"Helm catalog": "Catálogo do Helm",
	Help: Help,
	"Hide password": "Ocultar senha",
	"Host usage\n(used / total)": "Uso do host (usado/total)",
	"Hosts needed": "Hosts necessários",
	"Hosts requirements met": "Requisitos de hosts atendidos",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Hora (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "Concordo em usar meu token para criar uma política de serviço para serviço entre o serviço de origem {{sourceServiceDisplayName}} e o serviço de destino {{serviceDisplayName}} em meu nome.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "Confirmo que desejo parar de receber logs de plataforma de {{instance}}",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "Confirmo que desejo parar de receber métricas de plataforma de {{instance}}",
	"IaaS ready": "Preparado para IaaS (Infraestructure as a Service)",
	IAM: IAM,
	"IAM credentials": "Credenciais do IAM",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "Se nenhum conjunto de chaves for designado, a chave será incluída no conjunto de chaves padrão.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "Se for selecionado, a matriz será salva como uma sequência \"__NOT_SET__\".",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "Se o valor inicial não for uma matriz de sequência de caracteres válida, uma matriz com um único item ou vazia, aparecerá abaixo.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "Se as tags do usuário estiverem relacionadas ao faturamento, considere gravá-las como pares chave-valor, como",
	Images: Images,
	"Import your own key": "Importe sua própria chave",
	"In progress": "Em andamento",
	"in progress state": "estado em andamento",
	Inactive: Inactive,
	"inactive state": "estado inativo",
	Incomplete: Incomplete,
	"incomplete state": "estado incompleto",
	Information: Information,
	"information state": "estado das informações",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Zonas de infraestrutura",
	Instance: Instance,
	"Instance ID": "ID da instância",
	"Instance location": "Local da instância",
	"Instance name": "Nome da instância",
	"Instance(s) in {{region}}": "Instância(s) em {{region}}",
	"Instance(s) in region": "Instâncias na região",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Erro interno do servidor. Espere um minuto e tente a ação novamente. Se o problema persistir, abra um chamado de suporte.",
	"Interpolated URI": "URI interpolado",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Objeto datahook inválido, usando as últimas opções válidas",
	"Invalid label name.": "Nome do rótulo inválido.",
	"Invalid label prefix or name.": "Prefixo ou nome de rótulo inválido.",
	"Invalid label value.": "Valor do rótulo inválido.",
	"Items per page:": "Itens por página:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Aliases de chave",
	"Key CRN": "CRN da chave",
	"Key description": "Descrição da chave",
	"Key description must be at least 2 characters and no more than 240 characters.": "A descrição da chave deve ter pelo menos 2 caracteres e não mais de 240 caracteres.",
	"Key ID": "ID da chave",
	"Key management": "Gerenciamento do usuário",
	"Key management service": "Serviço de gerenciamento de chaves",
	"Key material": "Material de chave",
	"Key material is required to import a key": "O material da chave é necessário para importar uma chave",
	"Key material length must be 128, 192, or 256 bits": "O comprimento do material da chave deve ser de 128, 192 ou 256 bits",
	"Key material must be base64": "O material da chave deve ser base64",
	"Key name": "Nome da chave",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Nome da instância do Key Protect",
	"Key ring": "Conjunto de chaves",
	"Key value": "Valor da chave",
	"Label must be of the form 'key:value'.": "O rótulo deve estar no formato 'chave:valor'.",
	"Label name must be no more than {{maxLength}} characters.": "O nome do rótulo não deve ter mais de {{maxLength}} caracteres.",
	"Label prefix must be a valid DNS subdomain.": "O prefixo do rótulo deve ser um subdomínio de DNS válido.",
	"Label prefix must be no more than {{maxLength}} characters.": "O prefixo do rótulo não deve ter mais de {{maxLength}} caracteres.",
	"Label value must be no more than {{maxLength}} characters.": "O valor do rótulo não deve ter mais de {{maxLength}} caracteres.",
	"Large (48px)": "Grande (48px)",
	"Last modified": "Última modificação",
	"Last scanned": "Última varredura",
	"Last updated": "Última atualização",
	Launch: Launch,
	"Launch activiting tracking": "Ativar rastreamento de ativação",
	"Launch in new window": "Ativar em uma nova janela",
	"Launch logging": "Ativar criação de log",
	"Launch monitoring": "Ativar monitoramento",
	"Learn more": "Saiba mais",
	"learn more.": "saiba mais.",
	"Learn more.": "Saiba mais.",
	"List of actions": "Lista de ações",
	"list of code sample types": "lista de tipos de amostra de código",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Indicador de carregamento",
	"Loading...": "Carregando...",
	"Locate by CRN within your account": "Localize por CRN em sua conta",
	Location: Location,
	"Location summary": "Resumo do local",
	"Location:": "Localização:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "A coleção de logs já está ativada para este recurso",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "A coleção de logs é ativada para este recurso e enviada para os destinos, conforme definido pela sua configuração de roteamento.",
	Logging: Logging,
	"Logging (error)": "Criação de log (erro)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "A criação de log é recomendada para otimizar a resolução de problemas e reduzir o tempo de inatividade",
	"Logging...": "Criando log...",
	London: London,
	"Looking for valid service to service authorization policy...": "Procurando por uma política válida de autorização de serviço para serviço...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Parece que você não tem as permissões necessárias para criar a política. Entre em contato com o administrador da conta",
	"Looks like you don't have access to view account information.": "Parece que você não tem acesso para visualizar as informações de conta.",
	"Looks like you don't have access to view the billing period": "Parece que você não tem acesso para visualizar o período de faturamento",
	"Looks like you don't have any scans": "Parece que você não tem nenhuma varredura",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Parece que você não tem o acesso necessário para visualizar essas informações. Entre em contato com o administrador de conta para verificar suas permissões.",
	"Looks like you don't have the correct access": "Parece que você não possui o acesso correto",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Parece que você não tem o acesso correto. Deve-se ter acesso ao serviço de destino para criar uma autorização entre os serviços.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Certifique-se de que você tenha Tópicos, Assinaturas e Destinos configurados no Event Notifications.",
	"Manage encryption by enabling a key management service (KMS).": "Gerencie a criptografia ativando um serviço de gerenciamento de chaves (KMS).",
	"Manage routing": "Gerenciar roteamento",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Gerencie o ciclo de vida de suas chaves de criptografia usadas para os recursos, serviços e aplicativos da IBM Cloud.",
	"Managed from": "Gerenciado por meio de",
	March: March,
	May: May,
	"Media gallery video": "Vídeo da galeria de mídia",
	"Medium (40px)": "Médio (40px)",
	"Metadata location": "Localização de metadados",
	Metro: Metro,
	"Minimum host requirements are met.": "Os requisitos mínimos de host são atendidos.",
	Minute: Minute,
	"Minute (UTC)": "Minuto (UTC)",
	"Missing prerequisite services": "Serviços de pré-requisito ausentes",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Modifique os argumentos transmitidos em seu datahook aqui.",
	"Mon-Fri": "Seg - Sex",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Monitore a conformidade de todos os seus ambientes configurando varreduras.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Monitore e audite a atividade da IBM Cloud para aumentar a segurança e a conformidade. <a>Saiba mais</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Mês (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "O nome já está em uso. Forneça um nome exclusivo.",
	"Name must be between 2 and 90 characters": "O nome deve ter entre 2 e 90 caracteres",
	"Name this project": "Nomear este projeto",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "Nova instância",
	Next: Next,
	"Next page": "Página seguinte",
	"Next: Customize": "Próximo: customizar",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "Nenhuma região do catálogo disponível",
	"No Cloud Object Storage instance is available.": "Nenhuma instância do Cloud Object Storage está disponível.",
	"No code preview has been configured for terraform. Please visit our docs to ": "Nenhuma visualização de código foi configurada para o Terraform. Visite nossos Docs para ",
	"No configurations available": "Nenhuma configuração disponível",
	"No events can be scheduled with your selected CRON expression.": "Nenhum evento pode ser planejado com sua expressão CRON selecionada.",
	"No Hyper Protect Crypto Services instances found": "Nenhuma instância do Hyper Protect Crypto Services localizada",
	"No instances found": "Nenhuma instância localizada",
	"No item matches the filters. Clear the filters and try again.": "Nenhum item corresponde aos filtros. Limpe os filtros e tente novamente.",
	"No items available to display. Select an instance and bucket to view objects.": "Não há nenhum item disponível para exibição. Selecione uma instância e um depósito para visualizar os objetos.",
	"No items match the current filter.": "Nenhum item corresponde ao filtro atual.",
	"No keys available": "Nenhuma chave disponível",
	"No matches found. To create new tags, contact your tag administrator.": "Nenhuma correspondência localizada. Para criar novas tags, entre em contato com o administrador da tag.",
	"No matching options": "Nenhuma opção correspondente",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "Nenhum ID de região correspondente está disponível nesta conta. Se você achar que isso é um erro, atualize a página ou entre em contato com o administrador.",
	"No plans found": "Nenhum plano localizado",
	"No regions available": "Sem regiões disponíveis",
	"No resource groups available": "Não há nenhum grupo de recursos disponível",
	"No secret available": "Nenhum segredo disponível",
	"No secret group available": "Nenhum grupo de segredos disponível",
	"No service instance available": "Nenhuma instância de serviço disponível",
	"No valid version update options are available.": "Nenhuma opção de atualização de versão válida está disponível.",
	"Non-compliant": "Fora de conformidade",
	None: None,
	"None available": "Nenhum(a) disponível",
	Normal: Normal,
	"Normal (48px)": "Normal (48px)",
	"Not authorized": "Não autorizado",
	"Not ready": "Não está pronto",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Object",
	"Object storage": "Armazenamento de objeto",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "O armazenamento de objetos é usado para armazenar dados sobre a sua localização e backups para os clusters de sua localização. <a>Saiba mais.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Uma vez por dia",
	"Once a month": "Uma vez por mês",
	"Once a week": "Uma vez por semana",
	"Once a year": "Uma vez por ano",
	Open: Open,
	"Open dashboard": "Abrir painel",
	"Open Dashboard": "Abrir painel",
	"Open menu": "Abrir menu",
	"Open page navigation menu": "Abrir o menu de navegação da página",
	"Open reference picker": "Abrir selecionador de referência",
	"Open tab list": "Abrir lista de guias",
	Osaka: Osaka,
	"Overflow menu": "Menu overflow",
	"Overflow Menu": "Menu overflow",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "página {{pageNumber}}",
	"Page Navigation": "Navegação de Página",
	"Page navigation menu": "Menu de navegação da página",
	"Page number": "Número de página",
	Pattern: Pattern,
	"Pay-As-You-Go": "Pagamento por uso",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Acesso à plataforma",
	"Platform logs from {{region}} will be sent to a new instance": "Os logs de plataforma de {{region}} serão enviados para uma nova instância",
	"Platform logs from {{region}} will be sent to an existing instance": "Os logs de plataforma de {{region}} serão enviados para uma instância existente",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "Os logs de plataforma de {{region}} serão enviados para a instância de destino. <a>Saiba mais</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "Os logs de plataforma serão coletados dos serviços ativados da IBM Cloud de acordo com o escopo de roteamento definido.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "<a>Inscreva-se</a> para criar ou <a>efetue login</a> antes de aplicar o código promocional.",
	"Prefix filter": "Filtro de prefixo",
	Premium: Premium,
	"Preparing master, workers...": "Preparando o mestre, os trabalhadores...",
	"Preparing master...": "Preparando o mestre...",
	"Prerequisite services installed": "Serviços de pré-requisito instalados",
	Previous: Previous,
	"Previous page": "Página anterior",
	"Pricing Plans": "Planos de precificação",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Forneça uma descrição mais detalhada da chave. Para proteger sua privacidade, não use dados pessoais, como seu nome ou localização, como uma descrição. Não é possível alterar isso após a criação de chave.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Fornece visibilidade do desempenho e da integridade de seu aplicativo de recursos desenvolvido na IBM Cloud.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "Pronto para aplicar?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Atualizar instâncias do Cloud Object Storage",
	"Refresh data": "Atualizar dados",
	"Refresh secrets": "Atualizar os segredos",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Remover classificação",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "A renderização de ganchos de modificação não é suportada para evitar mudanças de recurso inesperadas.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Solicitando a criação...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Reconfigurar Filtros",
	"Reset to default": "Reconfigurar para o padrão",
	"Reset zoom": "Reconfigurar zoom",
	"Resource Configuration": "Configuração de recursos do",
	"Resource group": "Grupo de recursos",
	"Resource group:": "Grupo de recursos:",
	"Resource list": "Lista de recursos",
	"Resource List": "Lista de recursos",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Recursos não incluídos no custo",
	"Restricted access": "Acesso restrito",
	Results: Results,
	"Retrying delete": "Tentando excluir novamente",
	"Retrying deploy": "Tentando implementar novamente",
	"Revert {{resetCount}} to default": "Reverta a {{resetCount}} para padrão",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Revisar as designações de acesso a {{resourceDisplayName}}",
	"Review settings in Event Notifications": "Configurações de revisão em Event Notifications",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Revise as políticas de grupo de acesso a seguir para assegurar que você está designando o nível de acesso correto.",
	"Rotation interval": "Intervalo de rotação",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "As políticas de rotação determinam o intervalo entre rotações de chave automáticas. Um intervalo de um mês, por exemplo, significa que uma chave será girada a cada 30 dias. Se a política já estiver ativada, isso significa que uma política de instância existe para essa instância e se nenhuma outra ação for executada, o intervalo de rotação mostrado será aplicado à chave. Se ela estiver desativada, ative-a para configurar uma política para essa chave.",
	"Rotation policy": "Política de rotação",
	"Rotation policy disabled": "Política de rotação desativada",
	"Route name": "Nome da rota",
	Routing: Routing,
	"Routing scope": "Escopo de roteamento",
	"Row height": "Altura da linha",
	"Sample not yet available": "Amostra ainda não disponível",
	"Sao Paulo": "São Paulo",
	"Sat-Sun": "Sáb - Dom",
	Satellite: Satellite,
	"Satellite container": "Contêiner Satellite",
	"Satellite location": "Localização do Satellite",
	"Satellite location base cost": "Custo base de localização do Satellite",
	"Satellite location base functionality": "Funcionalidade base do local Satellite",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Salvando...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "A áreas de trabalho Schematics e outros dados do projeto são armazenados na região e grupo de recursos selecionados. <a>Saiba mais.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "As áreas de trabalho Schematics são provisionadas nesta região. O seu projeto ainda pode implementar recursos em qualquer região.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "As áreas de trabalho Schematics são provisionadas neste grupo de recursos. O seu projeto ainda pode implementar recursos em qualquer grupo de recursos.",
	Search: Search,
	"Search in this instance": "Procurar nesta instância",
	Secret: Secret,
	"Secret configured": "Segredo configurado",
	"Secret group": "Grupo de segredos",
	"Secret type": "Tipo de segredo",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Valor seguro",
	"See details": "Consulte os detalhes",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Selecione um local para ver quais medidas você precisa tomar a seguir.",
	"Select a project": "Selecionar um projeto",
	"Select a reference": "Selecionar uma referência",
	"Select a region": "Selecione uma região",
	"Select a resource group": "Selecione um grupo de recursos",
	"Select a role to determine the level of access for the source service.": "Selecione uma função para determinar o nível de acesso do serviço de origem.",
	"Select a secret": "Selecionar um segredo",
	"Select a secret group": "Selecionar um grupo de segredos",
	"Select a service instance": "Selecionar uma instância de serviço",
	"Select all {{totalRowCount}} items": "Selecione todos os {{totalRowCount}} itens",
	"Select all rows on page": "Selecione todas as linhas na página",
	"Select an environment": "Selecionar um ambiente",
	"Select an existing configuration": "Selecionar uma configuração existente",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "Selecione uma instância do IBM Cloud Monitoring para receber métricas de plataforma",
	"Select an IBM Log Analysis instance to receive platform logs": "Selecione uma instância do IBM Log Analysis para receber logs de plataforma",
	"Select an instance": "Selecionar uma instância",
	"Select an instance to show keys": "Selecione uma instância para mostrar chaves",
	"Select an option...": "Selecionar uma opção...",
	"Select existing key": "Selecione uma chave existente",
	"Select from Secrets Manager": "Selecionar por meio do Secrets Manager",
	"Select KMS instance": "Selecionar instância do KMS",
	"Select namespaces": "Selecionar namespaces",
	"Select one or more namespaces": "Selecione um ou mais namespaces",
	"Select one or more projects": "Selecione um ou mais projetos",
	"Select prerequisites": "Selecionar pré-requisitos",
	"Select projects": "Selecionar projetos",
	"Select region and resource group": "Selecionar região e grupo de recursos",
	"Select row": "Selecionar linha",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Selecione a <a>IBM Cloud</a> mais próxima de onde sua infraestrutura reside para assegurar baixa latência de rede.",
	"Select the following tile to deploy it.": "Selecione o bloco a seguir para implementá-lo.",
	"Send all audit events from enabled resources in {{region}}.": "Envie todos os eventos de auditoria de recursos ativados em {{region}}.",
	"Send all available audit events in this account.": "Envie todos os eventos de auditoria disponíveis nessa conta.",
	"Send events to": "Enviar eventos para",
	"Send logs to": "Enviar logs para",
	"Send test notification": "Enviar notificação de teste",
	Sending: Sending,
	"Sent!": "Enviado.",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Projetos sem servidor",
	Service: Service,
	"Service access": "Acesso ao serviço",
	"Service authorization": "Autorização de serviço",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "A autorização de serviço é necessária para permitir que o Activity Tracker Event Routing se comunique com o Cloud Logs. Clique em <span>Autorizar agora</span> para criar uma política com escopo definido para todos os recursos do Cloud Logs nessa conta.",
	"Service authorization required": "Autorização de serviço necessária",
	"Service instance": "Instância de serviço",
	"Service name": "Nome do serviço",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "Deve-se fornecer a autorização de serviço a serviço para a instância. <a>Saiba mais</a>",
	"Service to service authorization policy found": "Política de autorização de serviço para serviço localizada",
	"Service to service authorization policy needed": "Política de autorização de serviço para serviço necessária",
	"Service type": "Tipo de serviço",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "A autorização de serviço para serviço não pôde ser verificada. Inclua manualmente e verifique as funções necessárias.",
	"Service-to-service authorization requirements are met.": "Os requisitos de autorização de serviço para serviço são atendidos.",
	"Set an interval (in months)": "Defina um intervalo (em meses)",
	"Set key rotation policy": "Configurar política de rotação de chave",
	"Set up auth": "Configurar autorização",
	Settings: Settings,
	"Short (32px)": "Baixa (32px)",
	"Show all filters": "Mostrar todos os filtros",
	"Show code sample": "Exibir amostra de código",
	"Show environments information": "Mostrar informações de ambientes",
	"Show error information": "Mostrar informações de erro",
	"Show information": "Mostrar informações",
	"Show less": "Mostrar menos",
	"Show more": "Mostrar mais",
	"Show more details": "Mostrar mais detalhes",
	"Show password": "Mostrar senha",
	"Show tooltip": "Mostrar dica de ferramenta",
	"Showing {{count}} item": "Mostrando {{count}} item",
	"Showing {{count}} items": "Mostrando {{count}} itens",
	Size: Size,
	"Small (32px)": "Pequeno (32px)",
	"Some events from {{serviceName}}:": "Alguns eventos de {{serviceName}}:",
	"Something went wrong": "Algo saiu errado",
	"Something went wrong.": "Ocorreu um problema.",
	"Something went wrong. Try reloading the page to see this information": "Ocorreu um problema. Tente recarregar a página para ver essas informações",
	Sort: Sort,
	"Sort ascending": "Classificação crescente",
	"Sort descending": "Classificação decrescente",
	Source: Source,
	"Source Details": "Detalhes da origem",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "A origem do serviço não existe na instância do Event Notifications. Entre em contato com o administrador.",
	"Source service": "Serviço de origem",
	"Specific namespaces not supported": "Namespaces específicos não suportados",
	"Specific projects not supported": "Projetos específicos não suportados",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Comece criando um cluster que seja adequado para executar suas cargas de trabalho.",
	"Start date": "Data de início",
	"Starting at": "Iniciar com",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "Os custos iniciais são baseados nessa configuração de recurso. É possível editar as configurações após incluir este produto em um projeto, o que pode afetar os custos.",
	State: State,
	Status: Status,
	"status icon": "ícone de status",
	"Stay in pattern": "Manter-se no padrão",
	"Steps complete": "Etapas concluídas",
	Storage: Storage,
	"Storage bucket (optional)": "Bucket de armazenamento (opcional)",
	"Storage configuration missing": "Configuração de armazenamento ausente",
	"Storage ready": "Armazenamento pronto",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Armazene, procure, analise, monitore e crie alertas sobre seus dados e eventos de criação de log da IBM Cloud.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "estado de sucesso",
	"Success! This promotion was applied to your account.": "Sucesso! Essa promoção foi aplicada na sua conta.",
	"Successfully created new Key Protect instance": "Nova instância do Key Protect criada com sucesso",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Plano de suporte",
	"Switch to folders view": "Alternar para a visualização de pastas",
	"Switch to objects view": "Alternar para visualização de objetos",
	Sydney: Sydney,
	"Syntax: ": "Sintaxe: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "Não foi possível criar a tag '{{tagName}}' porque o nome é inválido.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Tags:",
	"Tags: (optional)": "Tags: (opcional)",
	"Tall (64px)": "Alta (64px)",
	"Target destination": "Destino",
	"Target location": "Local de destino",
	"Target name": "Nome de destino",
	"Target selected": "Destino selecionado",
	"Target service instance": "Instância de serviço de destino",
	"Target type": "Tipo de destino",
	"Template error": "Erro de modelo",
	"Terms and conditions": "Termos e condições",
	"Test notification": "Notificação de teste",
	"The address field is required.": "O campo de endereço é obrigatório.",
	"The catalog window might have been blocked from opening.": "A abertura da janela do catálogo pode ter sido bloqueada.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "A instância do Event Notifications conectada foi excluída da conta. Para continuar usando notificações, desconecte a instância atual clicando em Desconectar no menu ( ⋮ ). Em seguida, conecte outra instância do Event Notifications.",
	"The description should not contain any leading or trailing whitespace characters.": "A descrição não deve conter nenhum caractere de espaço em branco inicial ou final.",
	"The description should not exceed {{limit}} characters in length.": "A descrição não deve exceder {{limit}} caracteres de comprimento.",
	"The following access is required:": "O acesso a seguir é necessário:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "A visualização de código a seguir exibe a solicitação correspondente como comandos da CLI. Use-a como um ponto de início para gravar sua própria automação. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "A visualização de código a seguir exibe a solicitação correspondente como chamadas da API de REST. Use-a como um ponto de início para gravar sua própria automação. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "A visualização de código a seguir exibe a solicitação correspondente com o Terraform. Use-a como um ponto de início para gravar sua própria automação. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "A visualização a seguir exibe a solicitação correspondente como código. Use-a como um ponto de início para gravar sua própria automação.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "Os recursos a seguir não foram incluídos na estimativa de custo, mas podem ter um custo associado.",
	"The IAM role manager for {{serviceName}}": "O gerenciador de funções do IAM para {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "A instância não pode ser acessada porque um autorização de serviço a serviço foi removida da conta. Crie uma autorização com acesso ao Event Source Manager entre {{sourceServiceName}} e Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "Não é possível preencher a lista de namespaces. Tente novamente mais tarde.",
	"The list of projects can't be populated. Try again later.": "Não é possível preencher a lista de projetos. Tente novamente mais tarde.",
	"The name is required.": "O nome é necessário.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "O nome deve ter {{max}} ou menos caracteres, começar com uma letra e conter apenas caracteres alfanuméricos, '-' e '.'",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "O nome de um namespace pode incluir apenas letras minúsculas, números e traços. O nome não pode iniciar nem terminar com um traço e deve ter no máximo 63 caracteres.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "O nome de um projeto pode incluir apenas letras minúsculas, números e traços. O nome não pode iniciar nem terminar com um traço e deve ter no máximo 63 caracteres.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "O nome deve conter apenas os caracteres alfanumérico, sublinhado, traços e espaço.",
	"The name should not contain any special characters.": "O nome não deve conter nenhum caractere especial.",
	"The name should not exceed {{limit}} characters in length.": "O nome não deve exceder {{limit}} caracteres de comprimento.",
	"The region is required.": "A região é necessária.",
	"The resource group is required.": "O grupo de recursos é necessário.",
	"The resource group window might have been blocked from opening.": "A abertura da janela do grupo de recursos pode ter sido bloqueada.",
	"The tag name must be in a key:value format": "O nome da tag deve estar em um formato chave:valor",
	"The tag name must be in a key:value format.": "O nome da tag deve estar no formato key:value.",
	"The window might have been blocked from opening.": "A janela pode ter sido bloqueada de abrir.",
	"There was a problem loading resource groups.": "Houve um problema ao carregar grupos de recursos.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "Essas funções permitem acesso para usar o serviço e executar chamadas da API de serviço. Cada função é customizada pelo serviço selecionado. Selecione todos os que se aplicarem. Consulte a documentação do serviço para obter mais detalhes.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "Essas funções são criadas por administradores na conta para customizar como o acesso é designado ao serviço. Clique no ícone Ações para a função para revisar quais ações estão mapeadas para essa função.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "Essas funções permitem que as ações sejam executadas nos recursos da plataforma, como criar uma instância, conectar instâncias a apps e designar acesso de usuário. Selecione todos os que se aplicarem.",
	"This field is required": "Este campo é necessário",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "Isso não está sendo enviado atualmente no envio e uma atualização da equipe responsável pela API está pendente.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "É assim que sua instância {{serviceName}} é referenciada no Event Notifications",
	"This project name \"{{name}}\" already exists, please choose another name.": "Este nome de projeto \"{{name}}\" já existe, escolha outro nome.",
	"This section is under construction, come back later.": "Esta seção está em construção, volte mais tarde.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "Este serviço requer armazenamento adicional designado ao cluster. Nenhuma configuração de armazenamento correspondente existe.",
	"This tag already exists. Choose another name for your tag.": "Essa tag já existe. Escolha outro nome para a sua tag.",
	"This value already exists.": "Este valor já existe.",
	"This view is not available for some account types": "Esta visualização não está disponível para alguns tipos de conta",
	"Three zone names are required": "Três nomes de zona são necessários",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "Para incluir a criptografia HPCS, siga estas etapas:",
	"To connect, the instance in this region must be configured for platform": "Para conectar, a instância nesta região deve ser configurada para a plataforma",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "Para controlar as notificações dos eventos gerados por {{serviceName}}, conecte-se a uma instância do Event Notifications. <a>Saiba mais</a>",
	"To create a new HPCS key, follow the steps below...": "Para criar uma nova chave HPCS, siga as etapas abaixo...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Total de contas",
	"Total estimated cost": "Custo total estimado",
	"Transaction ID": "ID de transação",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Tente novamente mais tarde ou entre em contato com o administrador da conta.",
	"Try again later.": "Tente novamente mais tarde.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Tente atualizar a página e, em seguida, executar a ação novamente para ver se o problema persiste. Se sim, certifique-se de que esteja usando um <a>navegador suportado</a> e verifique a <a>página de status</a> para ver se algo mais está acontecendo. Se ainda estiver passando por um problema, entre em contato com o <a>suporte</a> para obter ajuda.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Tente esperar alguns minutos e execute a ação novamente para ver se o problema persiste. Em caso afirmativo, verifique a <a>página de status</a> para ver se alguma outra coisa está acontecendo. Se ainda estiver passando por um problema, entre em contato com o <a>suporte</a> para obter ajuda.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Digite \"{{clusterName}}\" para confirmar",
	"Type \"{{name}}\" to confirm": "Digite \"{{name}}\" para confirmar",
	"Unable to configure activity tracker event routing.": "Não é possível configurar o roteamento de eventos do Activity Tracker.",
	"Unable to configure Activity Tracker integration.": "Não foi possível configurar a integração do Activity Tracker.",
	"Unable to configure Logging integration.": "Não é possível configurar a Integração de criação de log.",
	"Unable to configure logging.": "Não é possível configurar a criação de log.",
	"Unable to connect your service to Event Notifications service. Try again later.": "Não é possível conectar seu serviço ao serviço Event Notifications. Tente novamente mais tarde.",
	"Unable to create authorization policy.": "Não é possível criar política de autorização.",
	"Unable to create Satellite location": "Não é possível criar local do Satellite",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "Não é possível criar a política de serviço a serviço neste momento. Atualize a página ou tente novamente mais tarde.",
	"Unable to delete cluster": "Não é possível excluir o cluster",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Não é possível desconectar a instância do Event Notifications. Atualize a página ou tente novamente mais tarde.",
	"Unable to get cluster data": "Não é possível obter dados do cluster",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Não é possível obter detalhes da instância do Event Notifications. Atualize a página ou tente novamente mais tarde.",
	"Unable to get storage instances.": "Não é possível obter as instâncias de armazenamento.",
	"Unable to list clusters.": "Não é possível listar clusters.",
	"Unable to list locations.": "Não é possível listar localizações.",
	"Unable to load Activity Tracker service catalog data": "Não foi possível carregar os dados do catálogo de serviço do Activity Tracker",
	"Unable to load Cloud Logs service catalog data": "Não é possível carregar os dados do catálogo de serviço do Cloud Logs",
	"Unable to load cluster details.": "Não é possível carregar detalhes do cluster.",
	"Unable to load cluster update version options.": "Não é possível carregar opções de versão de atualização de cluster.",
	"Unable to load event routing settings": "Não é possível carregar as configurações de roteamento de eventos",
	"Unable to load event routing target instances": "Não é possível carregar as instâncias de destino de roteamento de eventos",
	"Unable to load event routing target instances.": "Não é possível carregar as instâncias de destino de roteamento de eventos.",
	"Unable to load event routing targets": "Não é possível carregar os destinos de roteamento de eventos",
	"Unable to load event routing targets.": "Não é possível carregar os destinos de roteamento de eventos.",
	"Unable to load IBM Cloud locations data": "Não foi possível carregar os dados dos locais da IBM Cloud",
	"Unable to load logging instances": "Não é possível carregar instâncias de criação de log",
	"Unable to load logging instances.": "Não é possível carregar instâncias de criação de log.",
	"Unable to load logging service catalog data": "Não é possível carregar os dados do catálogo de serviço de criação de log",
	"Unable to load logs routing targets": "Não é possível carregar os destinos de roteamento de logs",
	"Unable to load logs routing targets.": "Não é possível carregar os destinos de roteamento de logs.",
	"Unable to perform": "Não é possível executar",
	"Unable to retrieve cluster details": "Não é possível recuperar os detalhes do cluster",
	"Unable to retrieve data": "Não é possível recuperar dados",
	"Unable to retrieve location information.": "Não é possível recuperar as informações do local.",
	"Unable to retrieve project configurations.": "Não é possível recuperar as configurações do projeto.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Não é possível enviar a notificação de teste para a instância do Event Notifications. Tente novamente mais tarde.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Não é possível enviar a notificação de teste para a instância do Event Notifications. Verifique se os Tópicos estão configurados no Event Notifications.",
	"Unable to update cluster version.": "Não é possível atualizar a versão do cluster.",
	Unknown: Unknown,
	"unknown state": "estado desconhecido",
	"Unselect all rows": "Desmarcar todas as linhas",
	"Unselect row": "Desmarcar linha",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Versão não suportada. Atualize a versão para continuar a receber suporte.",
	"Upcoming scheduled events in your timezone": "Próximos eventos planejados em seu fuso horário",
	Update: Update,
	"Update available": "Atualização disponível",
	"Update cluster version": "Atualizar versão do cluster",
	"Update tags": "Atualizar tags",
	"Update version": "Versão da atualização",
	"Updating...": "Atualizando ...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Faça upgrade de sua conta para visualizar o período de faturamento.",
	"Usage based charges apply per gigabyte of audit events ingested.": "Encargos baseados em uso são aplicados por gigabyte de eventos de auditoria ingeridos.",
	"Usage based charges apply per gigabyte of logs ingested.": "Encargos baseados em uso são aplicados por gigabyte de logs ingeridos.",
	"Usage costs": "Custos de uso",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Use um segredo para gerenciar as suas credenciais para autenticação com segurança e de maneira centralizada. <a>Saiba mais</a>",
	"Use a secret?": "Deseja usar um segredo?",
	"Use existing": "Usar existente",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Use aliases de chave para identificar facilmente suas chaves. Um alias de chave é um nome customizado exclusivo e facilmente reconhecível.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Use as tags para organizar seus recursos. Se as tags do usuário estiverem relacionadas ao faturamento, considere gravá-las como pares chave-valor para ajudar a agrupar as tags relacionadas, como",
	"Use the options below to choose the item that the reference will be created for.": "Use as opções abaixo para escolher o item para o qual a referência será criada.",
	"User evaluation required": "Avaliação do usuário necessária",
	"User permissions failure": "Falha nas permissões de usuário",
	"User tags": "Tags de usuário",
	"User tags (optional": "Tags do usuário (opcional",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "As tags do usuário são visíveis em toda a conta. Evite incluir dados sensíveis no nome de tag.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "O valor deve ser uma matriz válida (por exemplo: [\"array\"]). Para especificar uma matriz nula, use \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Verifique se os serviços a seguir foram instalados no local: {{missingServices}}.",
	Version: Version,
	View: View,
	"View all": "Visualizar todos",
	"View audit events": "Visualizar eventos de auditoria",
	"View docs": "Visualizar documentos",
	"View error information": "Visualizar informações de erro",
	"View logging": "Visualizar criação de log",
	"View-only mode": "Modo somente visualização",
	"VPC Gen1": "VPC Geração 1",
	"VPC Gen2": "VPC Geração 2",
	Warning: Warning,
	"warning state": "estado de aviso",
	"Washington DC": "Washington DC",
	Wednesday: Wednesday,
	"What you will need:": "O que será necessário:",
	"What's the purpose of this project?": "Qual é o propósito deste projeto?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "Quando você exclui o cluster, todos os nós do trabalhador, apps e contêineres são excluídos permanentemente. Essa ação não pode ser desfeita Antes de continuar, certifique-se de fazer backup de todos os dados e arquivos de configurações necessários.",
	"Worker count": "Contagem de trabalhadores",
	Workloads: Workloads,
	"Wrong Syntax": "Sintaxe errada",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "Você já tem um local com este nome. Insira um nome exclusivo.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Você já tem uma instância do Security and Compliance Center. Para ver resultados, deve-se planejar sua primeira varredura criando um anexo.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "Não é possível modificar esta política devido ao seu nível de acesso ao recurso da política. Se você gostaria de ter a capacidade de modificá-la, entre em contato com o administrador para atualizar o seu acesso ao recurso.",
	"You can find a list of resources here once you create them.": "É possível localizar uma lista de recursos aqui depois de criá-los.",
	"You can find your resource details here after you create them.": "É possível localizar os detalhes do seu recurso aqui depois de criá-los.",
	"You can find your resources here after you create them.": "É possível localizar seus recursos aqui depois de criá-los.",
	"You can find your Satellite locations here after you create them.": "É possível localizar suas localizações de Satélite aqui depois de criá-las.",
	"You do not have access to any resource groups.": "Você não tem acesso a nenhum grupo de recursos.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "Você não tem acesso a nenhum grupo de recursos. <a>Crie</a> um grupo de recursos.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "Você não possui permissão para editar tags. Entre em contato com o administrador se precisar de maior acesso.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "Você não tem o acesso correto para incluir uma configuração em \"{{project}}\"",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "Você possui acesso restrito e pode não ser capaz de incluir ou remover tags. Entre em contato com o administrador se precisar de maior acesso.",
	"You haven't connected an Event Notifications service instance yet.": "Você ainda não conectou uma instância do serviço Event Notifications.",
	"You may also <a>create an instance</a>.": "Também é possível <a>criar uma instância</a>.",
	"You may also create a new one.": "Você também pode criar uma nova.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "Pode haver restrições baseadas em contexto ou políticas de IAM ativadas. Entre em contato com o administrador da conta",
	"You must have at least one active root key. Try creating a new one.": "Deve-se ter pelo menos uma chave raiz ativa. Tente criar uma nova.",
	"You need at least 1 topic to send a test notification.": "Você precisa de pelo menos 1 tópico para enviar uma notificação de teste.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "É necessário possuir a função Editor ou Administrador no serviço IBM Cloud Projects para este projeto. <a>Designe você mesmo o acesso</a> ou solicite acesso de seu administrador de conta.",
	"You're adding tags to:": "Você está incluindo tags em:",
	"You're editing tags for:": "Você está editando tags para:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "Você não está autorizado a se conectar a esta instância. Verifique suas permissões ou entre em contato com o administrador.",
	"You're using the newest version of the API server. There are no updates available at this time.": "Você está usando a versão mais recente do servidor de API. Não há atualizações disponíveis neste momento.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "Você atingiu o número máximo de tags que podem ser anexadas de uma única vez. Para anexar mais tags, salve suas mudanças primeiro.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Seu servidor de API está sendo atualizado para a versão {{version}}. Depois que terminar, é possível atualizar seus nós do trabalhador para a mesma versão.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Aumentar zoom da imagem",
	"Zoom out image": "Diminuir zoom da imagem"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, ptBr as default, hour, hr, mo, more, provided, region, resources, tag, tags };
